/**
 * Created by Jonas Wålekvist on 2023-01-17.
 */

import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {BS2} from "../../../BS2";
import {BS2Symbol, BS2SymbolStates} from "../../../reels/BS2Symbol";
import {BS2Statics} from "../../../config/BS2Statics";
import {GSAPUtils} from "../../../utils/GSAPUtils";
import {replaceWithNewSymbolDataType, SpinMode} from "../../../server/BS2Data";
import {SimpleReelModelSymbolData} from "../../../../core/reel/simplereel/SimpleReelModel";
import {BS2GameMode} from "../../../server/BS2GameMode";


export class LevelUpgradePresentation implements SimplePresentation {
    name: string = "LevelUpgradePresentation";

    constructor() {
    }

    shouldRun(): boolean {
        return (BS2.model.gameData && BS2.model.data.upgradeLevel && !BS2.model.gameData.brokeTheBank);
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                controller.finish();
            }
        });
        tl.add(() => controller.setSkipCallback());
        tl.add(BS2.reelView.collectBar.playLevelUp(BS2.model.data.nextLevel));
        tl.add([BS2.backgroundElements.switchLevel(BS2.model.data.nextLevel, true, false, BS2.model.data.wasFeatureBuy && BS2.model.gameData.featureName === BS2GameMode.FREESPIN_SUPER)], "<");
        tl.add(() => {
            BS2.reelView.freespinCounter.showShockWave();
            BS2.keypadPlugin.setZeroBetSpinCounter(BS2.model.data.freespinsLeft);
            BS2.reelView.freespinCounter.showCount(BS2.model.data.freespinsLeft);
            BS2.soundPlayer.startLevel(BS2.model.data.nextLevel);
        }, "<1")
        tl.add(this.getUpgradeSymbols(BS2.model.data.nextLevel), "<");
        tl.add(this.setReelSets());

        tl.to(this, {duration: 0.01});

    }

    private getUpgradeSymbols(currentLevel: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            symbolsToRemove: string[] = BS2Statics.getRemoveSymbols(currentLevel),
            symbolsToUpgrade: string[] = BS2Statics.getUpgradeSymbols(currentLevel),
            removeAnimations: gsap.core.Timeline[] = [],
            upgradeAnimations: gsap.core.Timeline[] = [],
            allVisibleSymbols: SimpleReelModelSymbolData[] = BS2.reelView.getAllVisibleSymbols();

        for (let symbolData of allVisibleSymbols) {
            if (!symbolData.removed && symbolsToRemove.indexOf(symbolData.name) >= 0) {
                //remove
                const symbol: BS2Symbol = <BS2Symbol>symbolData.positionable,
                    removeTl: gsap.core.Timeline = gsap.timeline();

                if (BS2.model.nextSpinMode() == SpinMode.AVALANCHE) {
                    symbolData.removed = true;
                    removeTl.add(symbol.getStateAnimation(BS2SymbolStates.UPGRADE_REMOVE));
                } else {
                    removeTl.add(symbol.getStateAnimation(BS2SymbolStates.UPGRADE_DEAD));
                }

                removeAnimations.push(removeTl);
            }
            if (!symbolData.removed && symbolsToUpgrade.indexOf(symbolData.name) >= 0) {
                //upgrade
                const reelIndex: number = BS2.reelView.reels[symbolData.reelId].model.visibleIndexToRealIndex(symbolData.reelPosition),
                    replaceData: replaceWithNewSymbolDataType = BS2.reelView.reels[symbolData.reelId].model.replaceWithNewSymbol(reelIndex, BS2Statics.UPGRADE_NAMES[symbolData.name])

                const oldSymbol: BS2Symbol = <BS2Symbol>replaceData.oldSymbol.positionable;
                const newSymbol: BS2Symbol = <BS2Symbol>replaceData.newSymbol.positionable;
                newSymbol.setMultiplier(oldSymbol.currMultiValue);
                newSymbol.alpha = 0;

                const upgradeTl: gsap.core.Timeline = gsap.timeline();
                upgradeTl.add(oldSymbol.getStateAnimation(BS2SymbolStates.UPGRADE));
                upgradeTl.add(gsap.to(newSymbol, {duration: 0.1, alpha: 1}));
                upgradeTl.add(gsap.to(oldSymbol, {duration: 0.01, alpha: 0}));
                upgradeTl.add(() => {
                    oldSymbol.destroy();
                });

                upgradeAnimations.push(upgradeTl);
            }
        }

        tl.add(GSAPUtils.createTimelineFromArray(removeAnimations, "<0.1"));
        tl.add(GSAPUtils.createTimelineFromArray(upgradeAnimations, "<0.1"), "<");

        return tl;
    }

    private setReelSets(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            BS2.reelView.setReeSet(BS2Statics.LEVEL_REEL_SETS[(BS2.model.data.nextMode === BS2GameMode.NORMAL || BS2.model.data.nextMode === BS2GameMode.AVALANCHE_NORMAL) ? 0 : BS2.model.data.nextLevel]);
        });
        return tl;

    }
}